import { RestResourcesOptions } from '../type'

export const baseResources: RestResourcesOptions = {
  admins: null,
  dashboards: null,
  permissions: null,
  roles: { fullTextSearchFields: ['name'] },
  auth: null,
  branches: null,
  services: null,
  emailconfig: null,
  branch_config: null,
  branch_config_override: { path: 'branch-config/override' },
  booking: null,
  reserve: { path: 'booking/reserve'},
  'booking-view': { path: 'booking' },
  'temporary-request': { path: 'booking/temporary' },
}
